import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartArea} from "@fortawesome/free-solid-svg-icons";

class NoErrorComponent extends React.Component {

    constructor(props, context) {
        super(props, context);
        let message = this.props.message;
        let action = this.props.action
        let footer = this.props.footer;
        switch (action) {
            case "clear_selection":
                message = "Selections Cleared.";
                footer = "Please select at least one dataset and one metric to display the charts";
                break;
            case "clear_metric":
                message = "No metrics selected.";
                footer = "Please select a metric";
                break;
            case "clear_dataset":
                message = "No dataset selected.";
                footer = "Please select a dataset";
                break;
            default:
                if (!message || !action) {
                    message = "No Error found in the latest computation.";}

                if (!footer || !action){
                    footer = "Please check after sometime.";}
        }
        this.state = {
            message: message,
            footer: footer
        }}

    render() {
        return (
            <div className="text-center text-muted py-5 w-100">
                <h1><i><FontAwesomeIcon icon={faChartArea}/></i></h1>
                <h4>{this.state.message}</h4>
                <p>{this.state.footer}</p>
            </div>
        );
    }
}

export default NoErrorComponent;
